export const resizeImage = (file, maxDim = 900) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => {
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL("image/jpeg", 0.8));
    };
    img.onerror = reject;
    img.src = reader.result;
  };
  reader.onerror = reject;
  reader.readAsDataURL(file);
});

export const displayName = (c) => c.company_name || `${c.first_name || ""} ${c.last_name || ""}`.trim() || "Sans nom";

export const initials = (c) => {
  const n = displayName(c);
  const parts = n.split(" ").filter(Boolean);
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || "?";
};

export const PLACE_TYPES = ["Appartement", "Maison", "Restaurant", "Commerce", "Extérieur", "Studio", "Salle", "Bureau", "Autre"];
